import HttpService from './http.service';

class TreatmentCategoriesService {
  getTreatmentCategories() {
    return HttpService.get('treatment_categories')
      .then((res) => res.data);
  }

  suggestTreatmentCategories(params) {
    return HttpService.get('treatment_categories/suggestions', { params })
      .then((res) => res.data);
  }

  getTreatmentCategory(id) {
    return HttpService.get(`treatment_categories/${id}`)
      .then((res) => res.data);
  }

  createTreatmentCategory(treatmentCategory) {
    return HttpService.post('treatment_categories', treatmentCategory)
      .then((res) => res.data);
  }

  updateTreatmentCategory(treatmentCategory) {
    return HttpService.patch(`treatment_categories/${treatmentCategory.id}`, treatmentCategory)
      .then((res) => res.data);
  }

  deleteTreatmentCategory(treatmentCategory) {
    return HttpService.delete(`treatment_categories/${treatmentCategory.id}`)
      .then((res) => res.data);
  }
}

export default new TreatmentCategoriesService();
